@if (title) {
    <header class="title">
        <h2>{{ title }}</h2>
    </header>
}
